export const Const = {
    TagPublicMessageForwardingProtocol: '{||EncaminhamentoProtocolo||}',
    TagPublicMessageForwardingLink: '{||EncaminhamentoLink||}',
    TagPublicMessageProcessProtocol: '{||ProcessoProtocolo||}',
    TagPublicMessageProcessLink: '{||ProcessoLink||}'
};
